/**
 * @author weilan
 * @time 2020.05.20
 * @name 无需服务端获取的微应用
 */

const noAuthApps = [
  {
    module: "login",
    defaultRegister: true,
    devEntry: "/auth-static/",
    // devEntry: "http://localhost:6070",
    // devEntry: "https://boe.51qqt.com/auth-static/",
    depEntry: "/auth-static/",
    routerBase: "/login"
  }
];

export default noAuthApps;
